import { useEffect, useState } from "react";
import DocumentiFieraTable from "./DocumentiFieraTable";
import { Card, Icon } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CaricaFile from "./CaricaFile";
import UtilityService from "services/API/utility/UtilityService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import MDTypography from "common/components/MD/MDTypography";
import SpazioComponent from "./SpazioComponent";
import { MobileFriendly } from "@mui/icons-material";
import MDBox from "common/components/MD/MDBox";
import SpazioComponentMini from "./SpazioComponentMini";
import MDButton from "common/components/MD/MDButton";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import ServizioFieraComponent from "./ServizioFieraComponent";
import HeaderForm from "layouts/components/HeaderForm";

function ServiziFieraComponent({ servizio }) {

      const [ffcontroller] = useFarFieraUIController();
      const { manifestazione } = ffcontroller;
    const [part, setPart] = useState({
    });

    
      useEffect(() => {
        filtra();
      }, [manifestazione]);
    
        function filtra() {
        setPart({ idPartecipazione: 0, moduli_obbligatori: [{ id_modulo: 0, nome_modulo: '' }] });
        console.log("Cambiata pp->seleziono i dettagli :" + manifestazione);
        ExpoPartecipazioniService.seleziona_partecipazione(manifestazione)
          .then(response => {
           // console.log(response.data);
            setPart({
              idPartecipazione: response.data.idPartecipazione,
              id_utente: response.data.id_utente,
              nome_pdf_contratto: response.data.nome_pdf_contratto,
              richieste: response.data.richieste,
    
            });
    
    
    
    
          })
          .catch(e => {
            console.log(e);
    
          });
    
      }

    async function download_pdf_modello() {

        UtilityService.downloadModulo(servizio.idFile)
            .then(response => {

                return response.data;
            })
            .then(blob => {

                var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                var url = URL.createObjectURL(blobb);
                var a = document.createElement('a');
                a.href = url;
                a.target = "_blank";

                a.download = servizio.nome_file;
                ;

                document.body.appendChild(a); // append the element to the dom
                a.click();
                a.remove(); // afterwards, remove the element  
            })
            .catch(error => {
                console.error(error);
            });




    }




    return (
        <Card >
              <HeaderForm titolo={servizio.nome_modulo} color="info" />
            <MDBox mx={10}>
           

            <MDBox sx={{ display: 'grid', gap: 10, gridTemplateColumns: '3fr 3fr' }} mt={4} mb={1}>
                <MDTypography variant="h6"  >Scarica il file, compilalo e ricaricalo tramite il pulsante seguente per la tipologia espositiva oggetto! </MDTypography>
                <MDBox>  <MDButton variant="outlined" color="success" onClick={download_pdf_modello}  >
                    Scarica il pdf
                </MDButton></MDBox>
            </MDBox>
            {(part && part.idPartecipazione) &&
                <MDBox pt={3}>
                  {part.richieste.map((richiesta) => (
                    <ServizioFieraComponent richiesta={richiesta} filtra={filtra} servizio={servizio} />

                  ))}
                </MDBox>
              }


            {/*   <SpazioComponentMini
                key={richiesta.idRichiesta}
                id={richiesta.idRichiesta}
                richiesta={richiesta}
            />
            <MDBox mx={10}>
                <MDBox mb={2} ><MDTypography color='success'>Moduli Obbligatori</MDTypography></MDBox>
            <DocumentiFieraTable
                canSearch={false}
                table={ppTableData}
                nome_tabella="documenti"
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
                responsive={true}
                filtro_server={false}
                canExport={false}
                canSend={false}
                enableColumnFilters={false}

            />
        </MDBox>
        
                     {!part.idPartecipazione &&


                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non sei abilitato ad accedere a questa area!
                  </MDTypography></MDBox>

              }
        
        */}
        </MDBox>
        </Card>
    );

}
export default ServiziFieraComponent;
